import React from 'react';

export default function RecipeSkeleton() {
  return (
    <li className="personal-recipes-data-list__item personal-recipes-data-list__item--skeleton">
      <div className="personal-recipes-data-list__item-information">
        <div className="personal-recipes-data-list__item-date">
          <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 8 }} />
          <div className="skeleton-line skeleton-line--md" />
        </div>
        <div className="skeleton-line skeleton-line--sm" style={{ width: 90 }} />
      </div>

      <ul className="personal-recipes-list">
        {[0, 1].map((i) => (
          <li className="personal-recipes-list-item" key={i}>
            <div className="personal-recipes-list-item-drug">
              <div className="personal-recipes-list-item-about">
                <div className="skeleton-line skeleton-line--lg" style={{ marginBottom: 8 }} />
                <div className="skeleton-line skeleton-line--md" />
              </div>
              <div className="personal-recipes-list-item-use-wrapper">
                <div className="personal-recipes-list-item-use">
                  <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 6 }} />
                  <div className="skeleton-line skeleton-line--md" />
                </div>
                <div className="personal-recipes-list-item-use">
                  <div className="skeleton-line skeleton-line--sm" style={{ marginBottom: 6 }} />
                  <div className="skeleton-line skeleton-line--sm" />
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </li>
  );
}
